import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeRichText } from '../utils/rich-text-sanitizer';

// The one place stored rich text is trusted: it is allowlist-cleaned first, and only the video
// players this pipe builds itself are added afterwards.
@Pipe({
  name: 'sanitize'
})
export class SanitizePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value?: string | null): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.ParseDescription(sanitizeRichText(value ?? '')));
  }

  ParseDescription (description:any) {
    //embed YouTube & Vimeo videos
    if (description && description.indexOf('<oembed') > 0) {
      description = description.replaceAll('<figure', '<figure style="position:relative;max-width:100%;width:516px;"');
      description = description.replaceAll('<oembed url=\"https://youtu.be/', '<div style="position:relative;width:100%;padding-bottom:56%;"><iframe width="560" height="315" style="width:100%;height:100%;position:absolute;" src="https://www.youtube.com/embed/'); //eslint-disable-line
      description = description.replaceAll('<oembed url=\"https://www.youtube.com/watch?v=', '<div style="position:relative;width:100%;padding-bottom:56%;"><iframe width="560" height="315" style="width:100%;height:100%;position:absolute;" src="https://www.youtube.com/embed/'); //eslint-disable-line
      description = description.replaceAll('<oembed url="https://vimeo.com', '<div style="position:relative;width:100%;padding-bottom:56%;"><iframe width="560" height="315" style="width:100%;height:100%;position:absolute;" src="https://player.vimeo.com/video');
      description = description.replaceAll('<oembed url=', '<div style="position:relative;width:100%;padding-bottom:56%;"><iframe width="560" height="315" style="width:100%;height:100%;position:absolute;" src=');
      description = description.replaceAll('"></oembed>', '" frameborder="0" allowfullscreen></iframe></div>');
    }

    return ((description || "").trim() === "<p></p>" || (description || "").trim() === "<p><br></p>") ? "" : description;
  }

}
